import React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";

class ConfirmationModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
    };
  }

  close() {
    this.props.closeModal();
  }

  confirm() {
    // Little hack there. Should have used proper callbacks, but the modal was used everywhere,
    // so used async/await no to break the existing code.
    var callback = async () => {
      await this.props.successCallback();
      this.close();
    };

    this.setState({ disabled: true }, callback);
  }

  stopEvent(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  render() {
    let sizeClassName = "";
    if (this.props.size) sizeClassName = "modal-" + this.props.size;

    var title = <FormattedMessage id="Confirm" />;
    if (this.props.title) title = this.props.title;

    var cancelButtonLabel = <FormattedMessage id="Cancel" />;
    if (this.props.cancelButtonLabel)
      cancelButtonLabel = this.props.cancelButtonLabel;

    // Il param "hideCancelButton" is passed and true, we do not display cancel button
    var cancelButtonElement = !this.props.hideCancelButton ? (
      <button
        type="button"
        className="btn btn-secondary"
        data-dismiss="modal"
        onClick={() => this.close()}
      >
        {cancelButtonLabel}
      </button>
    ) : (
      ""
    );

    var buttonConfirm = <FormattedMessage id="Confirm" />;
    if (this.props.modalButtonConfirm)
      buttonConfirm = this.props.modalButtonConfirm;

    return (
      <div className="modal-bg show" onClick={() => this.close()}>
        <div className="modal fade show">
          <div
            className={"modal-dialog " + sizeClassName}
            role="document"
            onClick={(e) => this.stopEvent(e)}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {title}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => this.close()}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">{this.props.content}</div>
              <div className="modal-footer">
                {cancelButtonElement}
                <button
                  type="button"
                  className={
                    this.props.buttonRed === undefined
                      ? "btn btn-info"
                      : "btn btn-danger"
                  }
                  onClick={() => this.confirm()}
                  disabled={this.state.disabled}
                >
                  {buttonConfirm}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationModal);
